import React from 'react';
import { Card, CardContent } from '@/components/ui/card';

interface ContentCardProps {
  title: string;
  children: React.ReactNode;
  className?: string;
}

export function ContentCard({ title, children, className = "" }: ContentCardProps) {
  return (
    <Card className={`border border-gray-200 shadow-sm hover:shadow-md transition-shadow ${className}`}>
      <CardContent className="p-6">
        <h3 className="text-base font-semibold mb-3 text-indigo-900">{title}</h3>
        <div className="text-sm text-gray-700 leading-relaxed">
          {children}
        </div>
      </CardContent>
    </Card>
  );
}